// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rELn","footer":"styles_footer__2K7q4"};